import { FC, useEffect, useState } from 'react';
import { Logo } from 'ui/components/Logo';
import { MessageBox } from 'ui/components/MessageBox';
import { PageWrapper } from 'ui/components/PageWrapper';
import { TabMenuProps } from 'ui/components/TabMenu';
import { demoState } from 'apis/general';
import { getClockIcon, getPlayIcon } from 'static/assets/icons';
import { useIonRouter } from '@ionic/react';
import { ERoutes } from '../../static/data/ERoutes';

/** This page is active untill the user starts the gome. */
export const WelcomePage: FC = () => {
  const router = useIonRouter();
  const [showMessage2, setShowMessage2] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowMessage2(true);
    }, 2000);
  }, []);

  const getMenuPropsForDemoState = (): TabMenuProps => {
    if (demoState.value === 0) {
      return {
        mainButtonText: 'Kl. 20',
        icon: getClockIcon(),
      };
    }
    return {
      mainButtonText: 'Spil',
      icon: getPlayIcon(),
      mainButtonClass: 'bg-success border-white animate-bounce',
      onMainClick: () => {
        router.push(ERoutes.INGAME, 'forward');
      },
    };
  };

  return (
    <PageWrapper menuProps={getMenuPropsForDemoState()}>
      <Logo />

      <MessageBox bottomRightElement={<p className="text-xl">👋</p>}>
        <p className="text-black font-bold">Spil med i aften kl. 20</p>
        <p className="text-black">Glæd dig til en ny omgang Alle mod 1, hvor Stephania og jeg vil teste en masse nye, sjove og skøre eksperimenter.</p>
      </MessageBox>

      {showMessage2 && (
        <MessageBox playSpawnSound={true}>
          <p className="text-black">Heeeeey! Imens du venter kan du prøve vores sjove mini spil forneden. Kan du slå min rekord?</p>
        </MessageBox>
      )}
    </PageWrapper>
  );
};
